import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface ShortlistCandidateJobParams {
  jobId: string;
  candidateId: string;
}

export const useShortlistCandidateJobMutation = () => {
  return useMutation({
    mutationFn: ({ jobId, candidateId }: ShortlistCandidateJobParams) =>
      fetchClient.POST('/jobs/{jobId}/candidates/{candidateId}/shortlist', {
        params: {
          path: {
            jobId,
            candidateId,
          },
        },
      }),
    onSettled: (_data, _error, variables) => {
      const { jobId, candidateId } = variables;
      const detailQueryKey = candidateJobQueryKeys.detail(jobId, candidateId);
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
      invalidateQuery(detailQueryKey)();
    },
  });
};
